import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class SearchBarComponent implements OnInit, OnChanges {

  @Input() placeholder: string = 'Search...';
  @Input() value: string = '';

  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();

  searchControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['value']) {
      return;
    }
    const nextValue = changes['value'].currentValue ?? '';
    if (nextValue !== this.searchControl.value) {
      this.searchControl.setValue(nextValue, { emitEvent: false });
    }
  }

  ngOnInit() {
    this.searchControl.setValue(this.value ?? '', { emitEvent: false });
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(value => this.onSearch.emit((value ?? '').toString()));
  }

  clearSearch(): void {
    if (!this.searchControl.value) {
      return;
    }
    this.searchControl.setValue('');
  }

  hasSearchValue(): boolean {
    return this.searchControl.value.trim().length > 0;
  }

}
